import { endpoints } from 'constants/endpoints';

import { FEED_TYPES } from 'services/helpers/feed';

import { sendRequest } from './sendRequest';

export const getMeshFeedApi = (offset = 0, limit = 8) => {
  const url = endpoints.feed.meshFeed;
  return sendRequest({
    url,
    method: 'GET',
    queryParams: {
      offset,
      limit,
    },
  });
};

export const getMyFeedApi = ({ employeeId, offset = 0, limit = 8, pageType, filterTagType, filterId, filters }) => {
  const url = endpoints.feed.myFeed;
  return sendRequest({
    url,
    method: 'POST',
    queryParams: {
      offset,
      limit,
      employeeId,
      pageType,
      filterTagType,
      filterId,
      isJsonRequired: true,
    },
    body: {
      filter: filters,
    },
    credentials: 'include',
  });
};

export const addReactionToFeedApi = ({ feedId, reactionType, feedType }) => {
  if (!feedId) throw new Error('Feed id not provided');
  const url = endpoints.feed.reaction(feedId);
  return sendRequest({
    url,
    method: 'PUT',
    queryParams: {
      feedType,
      reactionType,
    },
    credentials: 'include',
  });
};

export const removeReactionToFeedApi = ({ feedId, reactionType, feedType }) => {
  if (!feedId) throw new Error('Feed id not provided');
  const url = endpoints.feed.reaction(feedId);
  return sendRequest({
    url,
    method: 'DELETE',
    queryParams: {
      feedType,
      reactionType,
    },
    credentials: 'include',
  });
};

export const getFeedDetailApi = (feedId) => {
  if (!feedId) throw new Error('Feed id is not provided');
  const url = endpoints.feed.detail(feedId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: { type: FEED_TYPES.post },
  });
};
